import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { trackEvent } from "services/bigbrain-service";
import classnames from "classnames";
import Colors from "styles/colors";
import { GRID_TAG_CLICKED, GRID_TAG_HOVERED } from "constants/bigbrain-event-types";
import Checkbox from "../checkbox/checkbox";
import { StyledTagComponent } from "./tag-component.scss";
const TagComponent = ({ onClick, Icon, text, tagColor, selected, handleTagHoverStart, handleTagHoverEnd })=>{
    const [isHover, setIsHover] = useState(false);
    const [tagAnimation, setTagAnimation] = useState(false);
    const onTagClick = ()=>{
        setTagAnimation(true);
        trackEvent(GRID_TAG_CLICKED, {
            kind: text
        });
        onClick && onClick();
    };
    const onMouseEnter = ()=>{
        handleTagHoverStart();
        setIsHover(true);
        trackEvent(GRID_TAG_HOVERED, {
            kind: text
        });
    };
    const onMouseLeave = ()=>{
        handleTagHoverEnd();
        setIsHover(false);
    };
    return /*#__PURE__*/ _jsxs(StyledTagComponent, {
        color: Colors[tagColor],
        className: classnames("tag-component", {
            selected,
            "tag-animation": tagAnimation
        }),
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter,
        onClick: onTagClick,
        onAnimationEnd: ()=>setTagAnimation(false),
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                color: Colors[tagColor],
                checked: selected,
                hovered: isHover
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "icon",
                children: Icon && /*#__PURE__*/ _jsx(Icon, {
                    color: (selected || isHover) && Colors[tagColor]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text",
                children: text
            })
        ]
    });
};
export default TagComponent;
